// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".OrganizationHistory{position:relative}", "",{"version":3,"sources":["/home/jenkins/agent/workspace/dashboard_gsa/src/components/organization/OrganizationHistory.vue"],"names":[],"mappings":"AA0BA,qBACE,iBAAA","file":"OrganizationHistory.vue","sourcesContent":["@import \"@/styles/_variables.scss\";\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.OrganizationHistory {\n  position: relative;\n}\n"]}]);
// Exports
module.exports = exports;
